
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M7.28994 7.00001C7.73994 7.00001 7.95994 6.46001 7.63994 6.15001L5.34994 3.85001C5.14994 3.65001 4.83994 3.65001 4.63994 3.85001L2.34994 6.15001C2.03994 6.46001 2.25994 7.00001 2.70994 7.00001H3.99994V17H2.70994C2.25994 17 2.03994 17.54 2.35994 17.85L4.64994 20.14C4.84994 20.34 5.15994 20.34 5.35994 20.14L7.64994 17.85C7.95994 17.54 7.73994 17 7.28994 17H5.99994V7.00001H7.28994ZM10.9999 7.00001H20.9999C21.5499 7.00001 21.9999 6.55001 21.9999 6.00001C21.9999 5.45001 21.5499 5.00001 20.9999 5.00001H10.9999C10.4499 5.00001 9.99994 5.45001 9.99994 6.00001C9.99994 6.55001 10.4499 7.00001 10.9999 7.00001ZM20.9999 17H10.9999C10.4499 17 9.99994 17.45 9.99994 18C9.99994 18.55 10.4499 19 10.9999 19H20.9999C21.5499 19 21.9999 18.55 21.9999 18C21.9999 17.45 21.5499 17 20.9999 17ZM20.9999 11H10.9999C10.4499 11 9.99994 11.45 9.99994 12C9.99994 12.55 10.4499 13 10.9999 13H20.9999C21.5499 13 21.9999 12.55 21.9999 12C21.9999 11.45 21.5499 11 20.9999 11Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-format-line-spacing`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFormatLineSpacing

    ```js
    <b-new-b-icon-format-line-spacing />
    ```
</docs>


